import { createVideoRecordShortcut } from '@distribute/shared/utils';
import { environment } from '../../../environments/environment';

export const recordShortCut = createVideoRecordShortcut(
  environment.staticBaseTranscoderUrl
);
